module.exports = __webpack_public_path__ + "img/title-01.c12460d1.png";